
<app-spinner color="white" class="inline"></app-spinner>

<div class="greeting-container" [class.visible]="user">
    <div class="greeting">
        {{userGreeting}}
    </div>

    Just a second...
</div>